import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { ResetConfirmForm } from "@/components/ResetConfirmForm";

const searchSchema = z.object({
  token: z.string().optional(),
});

export const Route = createFileRoute("/reset")({
  validateSearch: (raw): { token?: string } => searchSchema.parse(raw),
  component: function ResetPage() {
    const { token } = Route.useSearch();
    return <ResetConfirmForm token={token ?? null} />;
  },
});
